module.exports = __webpack_public_path__ + "img/sm-2.7167e67c.png";